const _ = require('lodash');

module.exports = function publicPath(relativePath = '', context) {
  if (!_.isString(relativePath)) { return ''; }

  let newContext = context.data.root;
  if (typeof window !== 'undefined' && typeof window.ELEMENT_CLIENT_CONFIG === 'object') {
    newContext = window.ELEMENT_CLIENT_CONFIG;
  }

  const brandPublicFolder = _.get(newContext, 'brand_public_folder', '');

  return `${_.isString(brandPublicFolder) ? brandPublicFolder : ''}${relativePath}`;
};



// WEBPACK FOOTER //
// ./~/unicorn/shared/helpers/publicPath.js